export enum TypeCapaciteEnum {
  PME_SECONDAIRE = 'PME_SECONDAIRE',
  PME_REMPLACER = 'PME_REMPLACER',
  AUTRE = 'AUTRE'
}
